(function($){

var TIMEOUT = 10000
var lastTime = (new Date()).getTime()

setInterval(function() {
    var currentTime = (new Date()).getTime()
    if (currentTime > (lastTime + TIMEOUT + 1000)) {
        $(document).wake()
    }
    lastTime = currentTime
}, TIMEOUT)

$.fn.wake = function(callback) {
    if (typeof callback === 'function') {
        return $(this).on('wake', callback)
    } else {
        return $(this).trigger('wake')
    }
}

})(jQuery)
